export const useAvailableCraftLocales = () => {
    const { locales } = useI18n();
    return locales.value.map((l) => l.craftSiteId);
}